import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const Methods = {
    
   
    methods: {

        getData(data)
        {
            this.options = data
        },

        getInitialData()
        {

        },

        async sendFixedData()
        {
            let http_obj = this.$refs.advanced_search.returnedRoomsToParent()

            if(!http_obj.checked_items.length)
            {
                notyf.error('No room was selected')

                return;
            }

            http_obj.unchecked_items = http_obj.unchecked_items.map(item => item.room_task_id)
            
            this.invoke_loader('post')

            const response = await this.patch(this.rest_api, http_obj)
            
            if(response.status)
            {
                this.notyfMesg("Success")
                setTimeout(() => {
                    window.location.href = `/budgeting-staffing-scenario/${this.scenario_id}`
                }, 300)
                this.revoke_loader('post')
            } 
            else
            {
                this.error_handling(response)
                this.revoke_loader('post')
            }
        },

        format_href(value)
        {
            return `<a href="#">${value}</a>`
        },


        fill_data(data)
        {
            this.parent           = data.scenario
            this.parent_id        = data.parent_id

            this.breadcrumb.push(
                {
                    name:   'Staffing Fixed',
                    href:   `/budgeting-staffing-scenario/${this.scenario_id}`,
                    arrow:  "<span class='slash'>/</span>",
                },
                {
                    name:   'Wizard',
                    href:   '#',
                    arrow:  "<span class='slash'>/</span>",
                },
                {
                    name:   this.parent.scenario,
                    href:   '#',
                    arrow:  "",
                }
            )
        },

        trashing(index)
        {
            this.wizzards.splice(index, 1)
        },
        
        reloaded()
        {
            window.location.reload()
        },


    },

}

export default Methods